import { z } from 'zod';
import { FACE_IDS, HAT_IDS, PAID_FIGURES, type AvatarItemId } from './avatar';

/**
 * The avatar shop on the profile page (Anne, 2026-10-26): figures, hats and things for the face
 * are bought here only, with PixelCoins earned in the games, and they are meant to be dear.
 * A new item needs its id in `avatar.ts`, a price here and a drawing in each game.
 */

export const SHOP_ITEMS = [...PAID_FIGURES, ...HAT_IDS, ...FACE_IDS] as const;
export type ShopItem = (typeof SHOP_ITEMS)[number];
export const shopItemSchema = z.enum(SHOP_ITEMS);

/** Prices in PixelCoins: about ten times what Mia used to ask. */
export const AVATAR_PRICES = {
  wizard: 400,
  knight: 500,
  robot: 500,
  visorKnight: 600,
  cyclops: 600,
  hooded: 600,
  ghost: 750,
  crab: 750,
  cap: 150,
  beanie: 150,
  bow: 150,
  strawHat: 200,
  partyHat: 200,
  flowerCrown: 250,
  chefHat: 250,
  pirateHat: 300,
  cowboyHat: 300,
  shellCrown: 300,
  topHat: 350,
  vikingHelmet: 450,
  pearlCrown: 500,
  starCrown: 1000,
  glasses: 150,
  freckles: 150,
  moustache: 200,
  eyepatch: 250,
  sunglasses: 250,
  beard: 350,
} as const satisfies Record<ShopItem, number>;

/** The dearest item, which is also the most the platform lets the shop charge at once. */
export const MAX_AVATAR_PRICE = Math.max(...Object.values(AVATAR_PRICES));

export function isShopItem(item: AvatarItemId): item is ShopItem {
  return (SHOP_ITEMS as readonly string[]).includes(item);
}

export const buyItemRequestSchema = z.object({ item: shopItemSchema });
export type BuyItemRequest = z.infer<typeof buyItemRequestSchema>;
